(($) => {
  $(document).ready(() => {

    // Open the overlay.
    const openOverlay = (overlay) => {
      overlay.removeClass('hidden');
      const body = $('body');
      // Make the scrollbar disappear.
      body.addClass('max-h-screen');
      body.addClass('overflow-y-hidden');
    }

    // Closes the overlay.
    const closeOverlay = (overlay) => {
      overlay.addClass('hidden');
      const body = $('body');
      body.removeClass('max-h-screen');
      body.removeClass('overflow-y-hidden');
    }

    $('.media--type-file.media--view-mode-default').on('click', (evt) => {
      const target = $(evt.currentTarget);
      const descriptionOverlay = target.find('.document-overlay');
      // Make sure evt.preventDefault(); isn't called if no overlay exists or
      // if the overlay is already open.
      if (!descriptionOverlay || !descriptionOverlay.hasClass('hidden')) {
        return null;
      }
      evt.preventDefault();
      openOverlay(descriptionOverlay);
    });

    // Check for overlay close clicks.
    // Only works for elements inside the overlay or the overlay itself.
    $('.document-overlay').on('click', (evt) => {
      // Don't propagate the vent.
      evt.stopPropagation();
      // Get the event target.
      const target = $(evt.target);
      // Check if the target closes the overlay.
      if (target.hasClass('document-overlay-back')) {
        // Get the overlay.
        const overlay = $(evt.currentTarget);
        // Close the overlay.
        closeOverlay(overlay);
      }
    });
  });
})(jQuery);
